var template = `
<div data-match-outer=".match-id." class="round.round-loser.__matches__match round.round-loser.__.round-id.__matches__match match.round-loser. match.round-loser.__.match-id. .match-value-stage.">
	<div data-match-inner=".match-id." class="round.round-loser.__matches__match__inner round.round-loser.__.round-id.__matches__match__inner match.round-loser.__inner .match-inner-null. match.round-loser.__.match-id.__inner" >
		<div class="match__inner__info">
			<span class="info__text info__text--match">Trận</span>
			<span class="info__text info__text--number">.match-value-number.</span>
			<span class="info__text info__text--date">.match-value-date.</span>
		</div>
		<div class="match__inner__competitors">
			<div class="competitors__team team team__.match-value-competitor-01. .match-value-competitor-nottbd-01."
				data-match-outer=".match-id." data-competitors-index-outer="0" 
				data-competitors-outer=".match-value-competitor-01." data-round-outer=".round-id.">				
				<div class="competitors__team__icon">
					<span class="icon__inner">
						.team-icon-01.
					</span>
				</div>
				<div class="competitors__team__text"
					data-match-outer=".match-id." data-competitors-index-outer="0" 
					data-competitors-outer=".match-value-competitor-01." data-round-outer=".round-id.">
					<span class="text__inner team__inner team__.match-value-competitor-01.__inner"
						data-match-inner=".match-id." data-competitors-index-inner="0" 
						data-competitors-inner=".match-value-competitor-01." data-round-inner=".round-id.">.match-value-competitor-name-01.</span>
				</div>
				<div class="competitors__team__score">
					<span class="score__inner .match-iswinner-01.">.match-value-score-01.</span>
				</div>
			</div>
			<div class="competitors__team team team__.match-value-competitor-02. .match-value-competitor-nottbd-01."
				data-match-outer=".match-id." data-competitors-index-outer="0" 
				data-competitors-outer=".match-value-competitor-02." data-round-outer=".round-id.">		
				<div class="competitors__team__icon">
					<span class="icon__inner">
						.team-icon-02.
					</span>
				</div>
				<div class="competitors__team__text"
					data-match-outer=".match-id." data-competitors-index-outer="1" 
					data-competitors-outer=".match-value-competitor-02." data-round-outer=".round-id.">
					<span class="text__inner team__inner team__.match-value-competitor-02.__inner"
						data-match-inner=".match-id." data-competitors-index-inner="1" 
						data-competitors-inner=".match-value-competitor-02." data-round-inner=".round-id.">.match-value-competitor-name-02.</span>
				</div>
				<div class="competitors__team__score">
					<span class="score__inner .match-iswinner-02.">.match-value-score-02.</span>
				</div>
			</div>
		</div>
	</div>
</div>`;

// var template = `
// <div data-match-outer=".match-id." class="round.round-loser.__matches__match round.round-loser.__.round-id.__matches__match match.round-loser. match.round-loser.__.match-id.">
// 	<div data-match-inner=".match-id." class="round.round-loser.__matches__match__inner round.round-loser.__.round-id.__matches__match__inner match.round-loser.__inner .match-inner-null. match.round-loser.__.match-id.__inner" >
// 		<div class="match__inner__info">
// 			<span class="info__text info__text--match">Trận</span>
// 			<span class="info__text info__text--number">.match-value-number.</span>
// 			<span class="info__text info__text--date">.match-value-date.</span>
// 		</div>
// 		<div class="match__inner__competitors">
// 			<div class="competitors__team team team__.match-value-competitor-01. .match-value-competitor-nottbd-01."
// 				data-match-outer=".match-id." data-competitors-index-outer="0" 
// 				data-competitors-outer=".match-value-competitor-01." data-round-outer=".round-id.">				
// 				<div class="competitors__team__icon">
// 					<span class="icon__inner">
// 						.team-icon-01.
// 					</span>
// 				</div>
// 				<div class="competitors__team__text"
// 					data-match-outer=".match-id." data-competitors-index-outer="0" 
// 					data-competitors-outer=".match-value-competitor-01." data-round-outer=".round-id.">
// 					<span class="text__inner team__inner team__.match-value-competitor-01.__inner"
// 						data-match-inner=".match-id." data-competitors-index-inner="0" 
// 						data-competitors-inner=".match-value-competitor-01." data-round-inner=".round-id.">.match-value-competitor-name-01.</span>
// 				</div>
// 				<div class="competitors__team__score">
// 					<span class="score__inner .match-iswinner-01.">.match-value-score-01.</span>
// 				</div>
// 			</div>
// 			<div class="competitors__team team team__.match-value-competitor-02. .match-value-competitor-nottbd-01."
// 				data-match-outer=".match-id." data-competitors-index-outer="0" 
// 				data-competitors-outer=".match-value-competitor-02." data-round-outer=".round-id.">		
// 				<div class="competitors__team__icon">
// 					<span class="icon__inner">
// 						.team-icon-02.
// 					</span>
// 				</div>
// 				<div class="competitors__team__text"
// 					data-match-outer=".match-id." data-competitors-index-outer="1" 
// 					data-competitors-outer=".match-value-competitor-02." data-round-outer=".round-id.">
// 					<span class="text__inner team__inner team__.match-value-competitor-02.__inner"
// 						data-match-inner=".match-id." data-competitors-index-inner="1" 
// 						data-competitors-inner=".match-value-competitor-02." data-round-inner=".round-id.">.match-value-competitor-name-02.</span>
// 				</div>
// 				<div class="competitors__team__score">
// 					<span class="score__inner .match-iswinner-02.">.match-value-score-02.</span>
// 				</div>
// 			</div>
// 		</div>
// 	</div>
// </div>`;

var variables = {
	"match-value-date" : "date",
	"match-value-number" : "match_number",
	"match-value-stage": "description"
}

$.fn.initTournamentDiagram = function(options){
    var defaults = {
      obj: $(this),
      objAppend: $(".dndbracket"),
    }
	var settings = $.extend(defaults, options);
	
	var rawData = settings.obj.val();
	var jsonData = JSON.parse(rawData);

	jsonData.data.template = 'modern';

	var $match_obj = settings.objAppend;
	var match_data = jsonData; 

	$match_obj.html(""); 
	if (match_data == null) return false;

	$('body').append(`
		<div id="tournament_diagram" class="tournament_diagram will-be-delete">
			<div class="dndbracket-rounds ${match_data.data.template}">
				<div class="round round__round_1">
					<div class="round__title round__round_1__title class_1">Test</div>
					<div class="round__matches round__round_1__matches"> 
						<div class="round__matches__match round__round_1__matches__match match match__match_1" data-match-outer="match_1">
						${template}
						</div>
					</div>
				</div>
			</div>
		</div>
	`);

	var round_width = $(".round").outerWidth() + parseInt($(".round").css("marginRight").replace('px',''));
	var match_height = $(".round__matches__match").outerHeight();

	switch (match_data.data.type) {
		case "1-or-2-matches": 
			$match_obj.css({
				width: round_width * (match_data.data.total_loser_rounds + 3.5),
			});
			break;
		case "1-match": 
			$match_obj.css({
				width: round_width * (match_data.data.total_loser_rounds + 2.5),
			});
			break;
		case "none": 
			$match_obj.css({
				width: round_width * (match_data.data.total_loser_rounds + 1),
			});
			break;
		case "roundrobin":
			$match_obj.css({
				width: '100%',
			});
			// 8 is just a random number, and the rounds bouding box is just list the matches (not positionable)
			break;
		default: 
			$match_obj.css({
				width: round_width * (match_data.data.rounds + 1.25),
			});
	}


	var css_config = {
		'drop' : `height: 91px; margin: 10px; width: 100%; background: #ecf0f1; border: 1px solid #FFF;`,
		'drop-team' : `height: 23px; margin: 3px; width: 100%; background: #ecf0f1; border: 1px solid #FFF;`,
	}
	var css = '';
	$.each(css_config, function(ic, vc){
		css += `.${ic}{${vc}}`;
	}); 

	if ($("#placeholder").length == 0) {
		$("head").append(`<style type="text/css" id="placeholder">${css}</style>`)
	}

	$(".will-be-delete").remove();

	// $match_obj.append(`<div class="rounds ${match_data.data.template}"></div>`);
	// $match_obj.append(`<div class="rounds-loser ${match_data.data.template}"></div>`);
	$match_obj.append(`<div class="dndbracket-rounds ${match_data.data.template}"></div>`);
	$match_obj.append(`<div class="dndbracket-rounds-loser ${match_data.data.template}"></div>`);
	$match_obj.append(`<div class="dndbracket-rounds-roundrobin ${match_data.data.template}"></div>`);
	$match_obj.append(`<div class="dndbracket-connections ${match_data.data.template}"></div>`);
	var $connection = $(".dndbracket-connections");


	if (['','default','none','1-match','1-or-2-matches'].includes(match_data.data.type)) {
		$.each(match_data.rounds, (ir,vr) => {
			$match_obj.children(".dndbracket-rounds").append(`
				<div class="round round__${ir} ${vr.class}">
					<div class="round__title round__${ir}__title">${vr.text}</div>
					<div class="round__matches round__${ir}__matches"></div>
				</div>
			`);
			$.each(vr.matches, function(im, vm){
				var competitors_name = [];
				competitors_name[0] = (match_data.teams[vm.competitors[0]] != undefined) ? match_data.teams[vm.competitors[0]].text : (match_data.loser_placeholder[vm.competitors[0]] != undefined) ? match_data.loser_placeholder[vm.competitors[0]].text : 'TBD';
				competitors_name[1] = (match_data.teams[vm.competitors[1]] != undefined) ? match_data.teams[vm.competitors[1]].text : (match_data.loser_placeholder[vm.competitors[1]] != undefined) ? match_data.loser_placeholder[vm.competitors[1]].text : 'TBD';	
				
				var isNotTBD_team1 = (vm.competitors[0] != 'TBD') ? 'team_placeholder' : '';
				var isNotTBD_team2 = (vm.competitors[1] != 'TBD') ? 'team_placeholder' : '';
				var isWin_team1 = (vm.competitors[0] == vm.winner) ? 'winner' : '';
				var isWin_team2 = (vm.competitors[1] == vm.winner) ? 'winner' : '';

				var competitors_code = [];
				competitors_code[0] = (match_data.teams[vm.competitors[0]] != undefined) ? match_data.teams[vm.competitors[0]].name : (match_data.loser_placeholder[vm.competitors[0]] != undefined) ? match_data.loser_placeholder[vm.competitors[0]].name : 'TBD';
				competitors_code[1] = (match_data.teams[vm.competitors[1]] != undefined) ? match_data.teams[vm.competitors[1]].name : (match_data.loser_placeholder[vm.competitors[1]] != undefined) ? match_data.loser_placeholder[vm.competitors[1]].name : 'TBD';	
				
				var url_team1 = (vm.competitors[0] != 'TBD') ?
									match_data.teams[competitors_code[0]].icon:'';
				var url_team2 = (vm.competitors[1] != 'TBD') ?
									match_data.teams[competitors_code[1]].icon:'';

				var logo_team1 = (url_team1 != '' && url_team1 != undefined && !url_team1.startsWith('.')) ? 
					`<img src="${url_team1}" alt="${competitors_name[0]}" />` : '';

				var logo_team2 = (url_team2 != '' && url_team2 != undefined && !url_team2.startsWith('.')) ? 
					`<img src="${url_team2}" alt="${competitors_name[1]}" />` : '';

				var score = [0, 0];
				$.each(vm.score, function(is, vs){
					score[0] += vs[0];
					score[1] += vs[1];
				})
				var match_is_null = (im.search("null") < 0) ? '' : 'match__inner--null';
				var round_is_loser = '';

				var match_dom = template;
				$.each(variables, (iv, vv) => {
					if (vm[vv] != undefined) {
						match_dom = match_dom.replace('.'+iv+'.', vm[vv]);
					}
				})
				match_dom = match_dom
								.replace(/\.round-loser\./g,round_is_loser)
								.replace(/\.round-id\./g,ir)
								.replace(/\.match-id\./g,im)
								.replace(/\.match-stage\./g,im)
								.replace(/\.match-inner-null\./g,match_is_null)
								.replace(/\.match-value-competitor-01\./g,competitors_code[0])
								.replace(/\.match-value-competitor-nottbd-01\./g,isNotTBD_team1)
								.replace(/\.match-value-competitor-name-01\./g,competitors_name[0])
								.replace(/\.match-value-score-01\./g,score[0])
								.replace(/\.match-iswinner-01\./g, isWin_team1)
								.replace(/\.match-value-competitor-02\./g,competitors_code[1])
								.replace(/\.match-value-competitor-nottbd-02\./g,isNotTBD_team2)
								.replace(/\.match-value-competitor-name-02\./g,competitors_name[1])
								.replace(/\.match-value-score-02\./g,score[1])
								.replace(/\.match-iswinner-02\./g, isWin_team2)
								.replace(/\.team-icon-01\./g, logo_team1)
								.replace(/\.team-icon-02\./g, logo_team2)
				$('.round__'+ir+'__matches').append(match_dom);
			});
		});	


		// Re-position match
		$.each(match_data.rounds, function(ir, vr){
			$.each(vr.matches, function(im, vm){
				if (ir == 'round_1') {
					$(".match__"+im).css({
						position: 'relative'
					})
				} else if (vm.type != undefined) {
					$(".match__"+im).css({
						position: 'absolute',
						top: $(".match__"+vm.prev[0]).offset().top - $(".round__title").outerHeight() - $(".round__matches").offset().top,
					})
				} else {
					$(".match__"+im).css({
						position: 'absolute',
						top: ($(".match__"+vm.prev[0]).offset().top + $(".match__"+vm.prev[1]).offset().top)/2 - settings.objAppend.offset().top - $(".round__title").outerHeight() - $(".match__"+im).css("marginTop").replace("px",""),					
					})
				}
			
			})
		})

		// Add connection (2 prev branches)
		for (var i = match_data.data.rounds; i > 0; i--) {
			$.each(match_data.rounds['round_'+i].matches, function(im, vm){
				if (!isNaN(vm.number)) {
					// console.log(vm);
					var pos = match_data.rounds['round_'+(i+1)].matches[vm.next[0]].prev.indexOf(im);
					if (pos == 0) {
						//connection bracket top
						console.log()
						var connection = {
							width: $(".round").css("marginRight").replace("px","")/2,
							height: Math.abs($(".match__"+vm.next[0]).offset().top - $(".match__"+im).offset().top) ,
							top: $(".match__"+im).offset().top - settings.objAppend.offset().top + $(".match").css("height").replace("px","")/2 + $(".round__title").outerHeight()/2 ,
							left: $(".match__"+im).offset().left + $(".match").outerWidth() - $match_obj.parent().offset().left - $match_obj.parent().css('paddingLeft').replace('px', ''),
						}
						$connection.append(`<div class="prev-a" style="position: absolute; width: ${connection.width}px; height: ${connection.height}px; top: ${connection.top}px; left: ${connection.left}px;"></div>`);
					} else {
						//connection bracket bottom
						var connection = {
							width: $(".round").css("marginRight").replace("px","")/2,
							height: Math.abs($(".match__"+vm.next[0]).offset().top - $(".match__"+im).offset().top),
							top: $(".match__"+im).offset().top - settings.objAppend.offset().top + $(".match").css("height").replace("px","")/2 - (Math.abs($(".match__"+vm.next[0]).offset().top - $(".match__"+im).offset().top)) + $(".round__title").outerHeight()/2 ,
							left: $(".match__"+im).offset().left + $(".match").outerWidth() - $match_obj.parent().offset().left - $match_obj.parent().css('paddingLeft').replace('px', ''),
						}
						$connection.append(`<div class="prev-b" style="position: absolute; width: ${connection.width}px; height: ${connection.height}px; top: ${connection.top}px; left: ${connection.left}px;"></div>`);
					}
				}
			});
		}

		// Add connection (next branches)
		for (var i = match_data.data.rounds+1; i > 1; i--) {
			$.each(match_data.rounds['round_'+i].matches, function(im, vm){
				if (vm.prev[0].indexOf("null") == -1 || vm.prev[1].indexOf("null") == -1) {
					//connection bracket line
					var connection = {
						width: $(".round").css("marginRight").replace("px","")/2,
						height: Math.abs($(".match__"+vm.prev[0]).offset().top - $(".match__"+im).offset().top),
						top: $(".match__"+im).offset().top - $match_obj.offset().top + $(".match").css("height").replace("px","")/2 - (Math.abs($(".match__"+vm.prev[0]).offset().top - $(".match__"+im).offset().top))  + $(".round__title").outerHeight()/2,
						left: $(".match__"+im).offset().left - $(".round").css("marginRight").replace("px","")/2 - $match_obj.parent().offset().left - $match_obj.parent().css('paddingLeft').replace('px', ''),
					}
					$connection.append(`<div class="next" style="width: ${connection.width}px; height: ${connection.height}px; top: ${connection.top}px; left: ${connection.left}px;"></div>`);
				}
			});
		}
	}
	if (['none','1-match','1-or-2-matches'].includes(match_data.data.type)) {	
		$.each(match_data.loser_rounds, (ir, vr) => {
			$match_obj.children(".dndbracket-rounds-loser").append(`
				<div class="round__loser round__${ir}">
					<div class="round__loser__title round__${ir}__title ${vr.class}">${vr.text}</div>
					<div class="round__loser__matches round__loser__${ir}__matches"> </div>
				</div>
			`);
			$.each(vr.matches, (im, vm) => {
				var competitors_name = []
				competitors_name[0] = (match_data.teams[vm.competitors[0]] != undefined) ? match_data.teams[vm.competitors[0]].text : (match_data.loser_placeholder[vm.competitors[0]] != undefined) ? match_data.loser_placeholder[vm.competitors[0]].text : 'TBD';
				competitors_name[1] = (match_data.teams[vm.competitors[1]] != undefined) ? match_data.teams[vm.competitors[1]].text : (match_data.loser_placeholder[vm.competitors[1]] != undefined) ? match_data.loser_placeholder[vm.competitors[1]].text : 'TBD';
				var isNotTBD_team1 = (vm.competitors[0] != 'TBD') ? 'team_placeholder' : '';
				var isNotTBD_team2 = (vm.competitors[1] != 'TBD') ? 'team_placeholder' : '';
				var competitors_code = [];
				competitors_code[0] = (match_data.teams[vm.competitors[0]] != undefined) ? match_data.teams[vm.competitors[0]].name : (match_data.loser_placeholder[vm.competitors[0]] != undefined) ? match_data.loser_placeholder[vm.competitors[0]].name : '';
				competitors_code[1] = (match_data.teams[vm.competitors[1]] != undefined) ? match_data.teams[vm.competitors[1]].name : (match_data.loser_placeholder[vm.competitors[1]] != undefined) ? match_data.loser_placeholder[vm.competitors[1]].name : '';	
				
				var isWin_team1 = (vm.competitors[0] == vm.winner) ? 'winner' : '';
				var isWin_team2 = (vm.competitors[1] == vm.winner) ? 'winner' : '';

				var url_team1 = (competitors_code[0] != '' && !competitors_code[0].includes('loser')) ?
									match_data.teams[competitors_code[0]].icon:'';
				var url_team2 = (competitors_code[1] != '' && !competitors_code[1].includes('loser')) ?
									match_data.teams[competitors_code[1]].icon:'';

				var logo_team1 = (url_team1 != '' && url_team1 != undefined && !url_team1.startsWith('.')) ? 
					`<img src="${url_team1}" alt="${competitors_name[0]}" />` : '';

				var logo_team2 = (url_team2 != '' && url_team2 != undefined && !url_team2.startsWith('.')) ? 
					`<img src="${url_team2}" alt="${competitors_name[1]}" />` : '';
				// var isWin_team1 = (vm.winner = )
				var score = [0, 0];
				$.each(vm.score, function(is, vs){
					score[0] += vs[0];
					score[1] += vs[1];
				})
				var match_is_null = (im.search("null") < 0) ? '' : 'match__loser__inner--null';
				var round_is_loser = '__loser';

				var match_dom = template;
				$.each(variables, (iv, vv) => {
					if (vm[vv] != undefined) {
						match_dom = match_dom.replace('.'+iv+'.', vm[vv]);
					}
				})
				match_dom = match_dom
								.replace(/\.round-loser\./g,round_is_loser)
								.replace(/\.round-id\./g,ir)
								.replace(/\.match-id\./g,im)
								.replace(/\.match-inner-null\./g,match_is_null)
								.replace(/\.match-value-competitor-01\./g,competitors_code[0])
								.replace(/\.match-value-competitor-nottbd-01\./g,isNotTBD_team1)
								.replace(/\.match-value-competitor-name-01\./g,competitors_name[0])
								.replace(/\.match-value-score-01\./g,score[0])
								.replace(/\.match-value-competitor-02\./g,competitors_code[1])
								.replace(/\.match-value-competitor-nottbd-02\./g,isNotTBD_team2)
								.replace(/\.match-value-competitor-name-02\./g,competitors_name[1])
								.replace(/\.match-value-score-02\./g,score[1])
								.replace(/\.match-iswinner-01\./g, isWin_team1)
								.replace(/\.match-iswinner-02\./g, isWin_team2)
								.replace(/\.team-icon-01\./g, logo_team1)
								.replace(/\.team-icon-02\./g, logo_team2)
				$('.round__loser__'+ir+'__matches').append(match_dom);
			});
		})

		$.each(match_data.loser_rounds, function(ir, vr){
			$.each(vr.matches, function(im, vm){
				if (ir == 'loser_round_1') {
					$(".match__loser__"+im).css({
						position: 'relative'
					})
				} else {
					$(".match__loser__"+im).css({
						position: 'absolute',
						top: ($(".match__loser__"+vm.prev[0]).offset().top - $(".round__title").outerHeight() + $(".match__loser__"+vm.prev[1]).offset().top)/2 - $('.round__round_1').outerHeight() - $match_obj.offset().top - $(".round__loser__title").outerHeight() - $(".match__loser__"+im).css("marginTop").replace("px","") + $(".round__title").outerHeight()/2,					
					})
				}
			})
		})


		for (var i = match_data.data.total_loser_rounds-1; i > 0; i--) {
			$.each(match_data.loser_rounds['loser_round_'+i].matches, function(im, vm){
				if (!isNaN(vm.number)) {
					var pos = match_data.loser_rounds['loser_round_'+(i+1)].matches[vm.next[0]].prev.indexOf(im);
					if (pos == 0) {
						var connection = {
							width: $(".round__loser").css("marginRight").replace("px","")/2,
							height: Math.abs($(".match__loser__"+vm.next[0]).offset().top - $(".match__loser__"+im).offset().top),
							top: $(".match__loser__"+im).offset().top - $match_obj.offset().top + $(".match__loser").css("height").replace("px","")/2 + $(".round__title").outerHeight()/2,
							left: $(".match__loser__"+im).offset().left + $(".match__loser").outerWidth() - $match_obj.parent().offset().left - $match_obj.parent().css('paddingLeft').replace('px', ''),
						}
						$connection.append(`<div class="prev-a" style="width: ${connection.width}px; height: ${connection.height}px; top: ${connection.top}px; left: ${connection.left}px;
							"></div>`);
					} else {
						var connection = {
							width: $(".round__loser").css("marginRight").replace("px","")/2,
							height: Math.abs($(".match__loser__"+vm.next[0]).offset().top - $(".match__loser__"+im).offset().top),
							top: $(".match__loser__"+im).offset().top - settings.objAppend.offset().top + $(".match__loser").css("height").replace("px","")/2 - (Math.abs($(".match__loser__"+vm.next[0]).offset().top - $(".match__loser__"+im).offset().top))  + $(".round__title").outerHeight()/2,
							left: $(".match__loser__"+im).offset().left + $(".match__loser").outerWidth() - $match_obj.parent().offset().left - $match_obj.parent().css('paddingLeft').replace('px', ''),
						}
						$connection.append(`<div class="prev-b"
							style="
									width: ${connection.width}px; height: ${connection.height}px;
									top: ${connection.top}px; left: ${connection.left}px;
							"></div>`);
					}
				}
			});
		}


		for (var i = match_data.data.total_loser_rounds; i > 1; i--) {
			$.each(match_data.loser_rounds['loser_round_'+i].matches, function(im, vm){
				if (vm.prev[0].indexOf("null") == -1 || vm.prev[1].indexOf("null") == -1) {
					var connection = {
						width: $(".round__loser").css("marginRight").replace("px","")/2,
						height: Math.abs($(".match__loser__"+vm.prev[0]).offset().top - $(".match__loser__"+im).offset().top),
						top: $(".match__loser__"+im).offset().top - settings.objAppend.offset().top + $(".match__loser").css("height").replace("px","")/2 - (Math.abs($(".match__loser__"+vm.prev[0]).offset().top - $(".match__loser__"+im).offset().top))  + $(".round__title").outerHeight()/2,
						left: $(".match__loser__"+im).offset().left - $(".round__loser").css("marginRight").replace("px","")/2 - $match_obj.parent().offset().left - $match_obj.parent().css('paddingLeft').replace('px', ''),
					}
					$connection.append(`<div class="next"
						style="width: ${connection.width}px; height: ${connection.height}px;
								top: ${connection.top}px; left: ${connection.left}px;
						"></div>`);
				}
			});
		}


		if (match_data.data.type == '1-match' || match_data.data.type == '1-or-2-matches') {
			var number_round = match_data.data.rounds + 2;
			var number_match = match_data.data.total_match + 1;
			var last_round = match_data.data.rounds + 1;
			var last_match = match_data.data.total_match;
			// console.log(number_round, number_match)
			vm = match_data.rounds['round_'+number_round].matches['match_'+number_match];

			// console.log(".match__"+last_match)
			var connection = {
				width: parseInt($(".round__round_1").css("marginRight").replace("px","")) + round_width,
				height: Math.abs($(".match__match_"+last_match).offset().top 
					- $(".match__match_"+number_match).offset().top),
				top: $(".match__match_"+number_match).offset().top - settings.objAppend.offset().top + $(".match").css("height").replace("px","")/2 - (Math.abs($(".match__match_"+last_match).offset().top - $(".match__match_"+number_match).offset().top)) + $(".round__title").outerHeight()/2 ,
				left: $(".match__match_"+number_match).offset().left - $(".round").css("marginRight").replace("px","") - $match_obj.parent().offset().left - $match_obj.parent().css('paddingLeft').replace('px', ''),
			}
			$connection.append(`<div class="next" 
				style="width: ${connection.width}px; height: ${connection.height}px;
						top: ${connection.top}px; left: ${connection.left}px;
				"></div>`);


			if (match_data.data.type == '1-or-2-matches') {
				number_round = match_data.data.rounds + 3;
				number_match = match_data.data.total_match + 2;
				last_round = match_data.data.rounds + 2;
				last_match = match_data.data.total_match + 1;
				if (match_data.rounds['round_'+number_round] == undefined) {
					return false;
				}
				vm = match_data.rounds['round_'+number_round].matches['match_'+number_match];

				// console.log(".match__"+last_match)
				var connection = {
					width: $(".round").css("marginRight").replace("px",""),
					height: Math.abs($(".match__match_"+last_match).offset().top 
						- $(".match__match_"+number_match).offset().top),
					top: $(".match__match_"+number_match).offset().top - settings.objAppend.offset().top + $(".match").css("height").replace("px","")/2 - (Math.abs($(".match__match_"+last_match).offset().top - $(".match__match_"+number_match).offset().top)) + $(".round__title").outerHeight()/2 ,
					left: $(".match__match_"+number_match).offset().left - $(".round").css("marginRight").replace("px","") - $match_obj.parent().offset().left - $match_obj.parent().css('paddingLeft').replace('px', '') + round_width,
				}
				$connection.append(`<div class="next" 
					style="width: ${connection.width}px; height: ${connection.height}px;
							top: ${connection.top}px; left: ${connection.left}px;
					"></div>`);
			}
		}

		// fit loser-round height

		var dom_loser_round = $(".dndbracket-rounds-loser");
		dom_loser_round.css({
			height: dom_loser_round.outerHeight()/2 + match_height
		})



	}
	if (['roundrobin'].includes(match_data.data.type)) {
		$.each(match_data.roundrobin_rounds, (ir, vr) => {
			$match_obj.children(".dndbracket-rounds-roundrobin").append(`
				<div class="round__roundrobin round__${ir}">
					<div class="round__roundrobin__title round__${ir}__title ${vr.class}">${vr.text}</div>
					<div class="round__roundrobin__matches round__roundrobin__${ir}__matches"> </div>
				</div>
			`);
			$.each(vr.matches, (im, vm) => {
				var competitors_name = []
				competitors_name[0] = (match_data.teams[vm.competitors[0]] != undefined) ? match_data.teams[vm.competitors[0]].text : 'TBD';
				competitors_name[1] = (match_data.teams[vm.competitors[1]] != undefined) ? match_data.teams[vm.competitors[1]].text : 'TBD';
				var isNotTBD_team1 = (vm.competitors[0] != 'TBD') ? 'team_placeholder' : '';
				var isNotTBD_team2 = (vm.competitors[1] != 'TBD') ? 'team_placeholder' : '';
				var competitors_code = [];
				competitors_code[0] = (match_data.teams[vm.competitors[0]] != undefined) ? match_data.teams[vm.competitors[0]].name : (match_data.loser_placeholder[vm.competitors[0]] != undefined) ? match_data.loser_placeholder[vm.competitors[0]].name : 'TBD';
				competitors_code[1] = (match_data.teams[vm.competitors[1]] != undefined) ? match_data.teams[vm.competitors[1]].name : (match_data.loser_placeholder[vm.competitors[1]] != undefined) ? match_data.loser_placeholder[vm.competitors[1]].name : 'TBD';	
				
				var url_team1 = (vm.competitors[0] != 'TBD') ?
									match_data.teams[competitors_code[0]].icon:'';
				var url_team2 = (vm.competitors[1] != 'TBD') ?
									match_data.teams[competitors_code[1]].icon:'';

				var logo_team1 = (url_team1 != '' && url_team1 != undefined && !url_team1.startsWith('.')) ? 
					`<img src="${url_team1}" alt="${competitors_name[0]}" />` : '';

				var logo_team2 = (url_team2 != '' && url_team2 != undefined && !url_team2.startsWith('.')) ? 
					`<img src="${url_team2}" alt="${competitors_name[1]}" />` : '';

				var score = [0, 0];
				$.each(vm.score, function(is, vs){
					score[0] += vs[0];
					score[1] += vs[1];
				})
				var match_is_null = (im.search("null") < 0) ? '' : 'match__roundrobin__inner--null';
				// var round_is_roundrobin = '';
				var round_is_loser = '__roundrobin';

				var match_dom = template;
				$.each(variables, (iv, vv) => {
					if (vm[vv] != undefined) {
						match_dom = match_dom.replace('.'+iv+'.', vm[vv]);
					}
				})
				match_dom = match_dom
								.replace(/\.round-loser\./g,round_is_loser)
								// .replace(/\.round-roundrobin\./g,round_is_roundrobin)
								.replace(/\.round-id\./g,ir)
								.replace(/\.match-id\./g,im)
								.replace(/\.match-inner-null\./g,match_is_null)
								.replace(/\.match-value-competitor-01\./g,vm.competitors[0])
								.replace(/\.match-value-competitor-nottbd-01\./g,isNotTBD_team1)
								.replace(/\.match-value-competitor-name-01\./g,competitors_name[0])
								.replace(/\.match-value-score-01\./g,score[0])
								.replace(/\.match-value-competitor-02\./g,vm.competitors[1])
								.replace(/\.match-value-competitor-nottbd-02\./g,isNotTBD_team2)
								.replace(/\.match-value-competitor-name-02\./g,competitors_name[1])
								.replace(/\.match-value-score-02\./g,score[1])
								.replace(/\.team-icon-01\./g, logo_team1)
								.replace(/\.team-icon-02\./g, logo_team2)
				$('.round__roundrobin__'+ir+'__matches').append(match_dom);
			});
		})
	}

	$(".round--extra").css({
		'margin-left': round_width+"px"
	})

	$(".text__inner").each(function(){
		var text = $(this).html();
		if (text.length > 13) {
			$(this).css({
				'font-size': 13,
			})
		}
		if (text.length > 17) {
			$(this).css({
				'font-size': 11,
			})
		}
	})

	$(".competitors__team").on("mouseenter", function() {
		var $self = $(".team__"+$(this).data("competitors-outer")+"");
		if ($(this).data("competitors-outer") != 'TBD') {
			$self.addClass("active");	
		}
		// $self.addClass("active");	
	});
	$(".competitors__team").on("mouseleave", function() {
		var $self = $(".team__"+$(this).data("competitors-outer")+"");
		$self.removeClass("active");
	});

}